import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {reduxForm, Field} from 'redux-form';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';

import * as authActions from '../actions/auth';
import validate from '../validators/forms/set-password';
import FlashMessage from '../components/FlashMessage';
import TextInput from '../components/Form/TextInput';
import AppBlock from '../components/AppBlock';
import Title from '../components/Form/Title';
import TextPage from './TextPage';
import BackButton from '../components/BackButton';

const FORM_NAME = 'setPassword-form';

class AuthSetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSuccess: false
    };

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  /**
   * Form submit handler
   * @param values
   */

  handleFormSubmit(values) {
    const {user_id, code} = this.props.location.query;

    authActions
      .setAsync(
        this.props.dispatch,
        {
          user_id,
          code,
          password: values.password
        },
        this.props.location.query,
        this.props.xl
      )
      .then(response => {
        if (response && (response.status === 200 || response.status === 204)) {
          this.setState({isSuccess: true});
        }
      });
  }

  successMessage() {
    const {
      xl: {isIFrame},
      intl
    } = this.props;
    return (
      <div className="block-content">
        <div className="content-message">
          <div className="message">{intl.messages['auth-reset.success']}</div>

          <BackButton isIFrame={isIFrame} />
        </div>
      </div>
    );
  }

  render() {
    const {intl, auth, handleSubmit} = this.props;

    return (
      <Fragment>
        {!this.state.isSuccess ? (
          <AppBlock>
            <Title title={intl.messages['auth-reset.title']} />

            <div className="block-content">
              {auth.set.error !== null && <FlashMessage type="error" message={auth.set.error} />}

              <form onSubmit={handleSubmit(this.handleFormSubmit)}>
                <Field
                  component={TextInput}
                  name="password"
                  type="password"
                  label={intl.messages['form.password']}
                  required="true"
                  icon="password"
                  disabled={auth.registration.loading}
                />

                <Field
                  component={TextInput}
                  name="password_confirm"
                  type="password"
                  label={intl.messages['form.password_confirm']}
                  required="true"
                  icon="password"
                  disabled={auth.registration.loading}
                />

                <button
                  type="submit"
                  className="form-button button-with-bg"
                  disabled={auth.set.loading}
                >
                  {auth.set.loading
                    ? intl.messages['form.loading']
                    : intl.messages['auth-reset.set-password']}
                </button>
              </form>
            </div>
          </AppBlock>
        ) : (
          <TextPage content={this.successMessage()} title={intl.messages['auth-reset.title']} />
        )}
      </Fragment>
    );
  }
}

AuthSetPassword.propTypes = {
  location: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  xl: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    ...state,
    ...validate,
    form: FORM_NAME
  };
}

export default injectIntl(connect(mapStateToProps)(reduxForm()(AuthSetPassword)));



// WEBPACK FOOTER //
// ./pages/SetPassword.jsx